import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 路由懒加载：所有组件均通过动态 import 引入，避免首屏加载冗余代码
// 相同业务模块的组件用 webpackChunkName 分组，打包时会合并到同一个 JS 文件
export default new Router({
  // mode: 'history', // 如需去掉#号，可开启（需配合服务器配置）
  // base: '/h5atui/', // 如需自定义基础路径，可配置
  routes: [
    // 登录页
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "auth" */ '@/views/login/index'),
      meta: { title: '登录' }
    },

    // 体验购相关（分组打包到 "experience"  chunk）
    {
      path: '/experienceStation',
      name: 'experienceStation',
      component: () => import(/* webpackChunkName: "experience" */ '@/views/dashboard/experienceStation/index.vue'),
      meta: { title: '体验购' }
    },
    {
      path: '/experienceDetails',
      name: 'experienceDetails',
      component: () => import(/* webpackChunkName: "experience" */ '@/views/dashboard/experienceStation/main.vue'),
      meta: { title: '体验购' }
    },
    {
      path: '/jump',
      name: 'jump',
      component: () => import(/* webpackChunkName: "experience" */ '@/views/dashboard/experienceStation/Jump.vue'),
      meta: { title: '跳转' }
    },
    {
      path: '/show',
      name: 'show',
      component: () => import(/* webpackChunkName: "experience" */ '@/views/dashboard/experienceStation/show.vue'),
      meta: { title: '体验购介绍' }
    },
    {
      path: '/booth-lease-instruction',
      name: 'BoothLeaseInstruction',
      component: () => import(/* webpackChunkName: "experience" */ '@/views/dashboard/experienceStation/BoothLeaseInstruction.vue'),
      meta: { title: '租用展位说明' }
    },

    // 详情页相关（分组打包到 "detail"  chunk）
    {
      path: '/cinema',
      name: 'otherDetail',
      component: () => import(/* webpackChunkName: "detail" */ '@/views/dashboard/details/index'),
      meta: { title: '影院业务详情' }
    },
    // 下面这个东西有问题,但出问题了再说
    {
      path: '/goodsDetail',
      name: 'goodsDetail',
      component: () => import(/* webpackChunkName: "detail" */ '@/views/dashboard/details/goods'),
      meta: { title: '商品详情' }
    },
    {
      path: '/video',
      name: 'videoDetail',
      component: () => import(/* webpackChunkName: "detail" */ '@/views/dashboard/details/video') // ios无
    },
    {
      path: '/services',
      name: 'services',
      component: () => import(/* webpackChunkName: "detail" */ '@/views/dashboard/details/services')
    },
    {
      path: '/sharePriceDetail',
      name: 'sharePriceDetail',
      component: () => import(/* webpackChunkName: "detail" */ '@/views/dashboard/details/sharePriceDetail'),
      meta: { title: '推享金分配方案' }
    },
    {
      path: '/commodity',
      name: 'commodity',
      component: () => import(/* webpackChunkName: "detail" */ '@/views/dashboard/details/commodity')
    },

    // 首页与核心功能（分组打包到 "core"  chunk）
    {
      path: '/',
      name: 'dashboard',
      component: () => import(/* webpackChunkName: "core" */ '@/views/dashboard/index')
    },
    {
      path: '/rule',
      name: 'rule',
      component: () => import(/* webpackChunkName: "core" */ '@/views/dashboard/rule/pushRules'),
      meta: { title: '推享规则' }
    },
    {
      path: '/share',
      name: 'share',
      component: () => import(/* webpackChunkName: "core" */ '@/views/dashboard/share/shareRules'),
      meta: { title: '推享规则' }
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: () => import(/* webpackChunkName: "core" */ '@/views/dashboard/share/feedback'),
      meta: { title: '反馈' }
    },
    {
      path: '/getOutlLine',
      name: 'getOutlLine',
      component: () => import(/* webpackChunkName: "core" */ '@/views/dashboard/getOutlLine'),
      meta: { title: '阿推社区行为规范' }
    },

    //  particulars 相关（分组打包到 "particulars"  chunk）
    {
      path: '/particulars',
      name: 'particulars',
      component: () => import(/* webpackChunkName: "particulars" */ '@/views/dashboard/particulars/particulars')
    },
    {
      path: '/HasWantParticulars',
      name: 'HasWantParticulars',
      component: () => import(/* webpackChunkName: "particulars" */ '@/views/dashboard/particulars/HasWantParticulars/index'),
      meta: { title: '我有我要详情页' }
    },
    {
      path: '/particularsWin',
      name: 'particularsWin',
      component: () => import(/* webpackChunkName: "particulars" */ '@/views/dashboard/particulars/indexWin.vue'),
      meta: { title: '我的窗口详情页' }
    },
    {
      path: '/articleDetails',
      name: 'articleDetails',
      component: () => import(/* webpackChunkName: "particulars" */ '@/views/dashboard/particulars/index'),
      meta: { title: '文章详情' }
    },

    //  push 相关（分组打包到 "push"  chunk）
    {
      path: '/pushOndetails',
      name: 'pushOndetails',
      component: () => import(/* webpackChunkName: "push" */ '@/views/dashboard/pushOndetails')
    },
    {
      path: '/pushOndetailsHas',
      name: 'pushOndetailsHas',
      component: () => import(/* webpackChunkName: "push" */ '@/views/dashboard/pushOndetails/newindex')
    },
    {
      path: '/pushOndetailswin',
      name: 'pushOndetailswin',
      component: () => import(/* webpackChunkName: "push" */ '@/views/dashboard/pushOndetails/windowIndex')
    },
    {
      path: '/pushDetail',
      name: 'pushDetail',
      component: () => import(/* webpackChunkName: "push" */ '@/views/dashboard/pushDetail'),
      meta: { title: '推享链活动' }
    },
    {
      path: '/pushDetailHas',
      name: 'pushDetailHas',
      component: () => import(/* webpackChunkName: "push" */ '@/views/dashboard/pushDetail/newindex'),
      meta: { title: '推享链活动我有我要' }
    },
    {
      path: '/pushDetailWin',
      name: 'pushDetailWin',
      component: () => import(/* webpackChunkName: "push" */ '@/views/dashboard/pushDetail/windowIndex'),
      meta: { title: '推享链活动我的窗口' }
    },
    {
      path: '/newTweetDetails',
      name: 'newTweetDetails',
      component: () => import(/* webpackChunkName: "push" */ '@/views/dashboard/newTweetDetails')
    },

    //  活动与福利相关（分组打包到 "activity"  chunk）
    {
      path: '/actionRule',
      name: 'actionRule',
      component: () => import(/* webpackChunkName: "activity" */ '@/views/actionRule/index'),
      meta: { title: '活动规则' }
    },
    {
      path: '/luckyDraw',
      name: 'luckyDraw',
      component: () => import(/* webpackChunkName: "activity" */ '@/views/dashboard/luckyDraw/index'),
      meta: { title: '抽奖' }
    },
    {
      path: '/article',
      name: 'article',
      component: () => import(/* webpackChunkName: "activity" */ '@/views/dashboard/luckyDraw/article'), // ios无
      meta: { title: '商品详情' }
    },
    {
      path: '/merchandise',
      name: 'merchandise',
      component: () => import(/* webpackChunkName: "activity" */ '@/views/dashboard/luckyDraw/merchandise'), // ios无
      meta: { title: '商品详情' }
    },
    {
      path: '/freeExperience',
      name: 'freeExperience',
      component: () => import(/* webpackChunkName: "activity" */ '@/views/freeExperience/index.vue'),
      meta: { title: '免费体验' }
    },
    {
      path: '/useFreeExperience',
      name: 'useFreeExperience',
      component: () => import(/* webpackChunkName: "activity" */ '@/views/dashboard/useFreeExperience'),
      meta: { title: '免费体验活动' }
    },
    {
      path: '/atuiactivity',
      name: 'atuiactivity',
      component: () => import(/* webpackChunkName: "activity" */ '@/views/dashboard/atuiactivity'),
      meta: { title: '阿推活动' }
    },
    {
      path: '/NationalDay',
      name: 'NationalDay',
      component: () => import(/* webpackChunkName: "activity" */ '@/views/dashboard/temporary/NationalDay.vue'),
      meta: { title: '新年快乐' }
    },
    {
      path: '/NationalDay1',
      name: 'NationalDay1',
      component: () => import(/* webpackChunkName: "activity" */ '@/views/dashboard/temporary/NationalDay1.vue'),
      meta: { title: '放假通知' }
    },

    //  推广与商户相关（分组打包到 "promotion"  chunk）
    {
      path: '/promotion',
      name: 'promotion',
      component: () => import(/* webpackChunkName: "promotion" */ '@/views/dashboard/promotion'),
      meta: { title: '推享赚详情' }
    },
    {
      path: '/promotiondetails',
      name: 'promotiondetails',
      component: () => import(/* webpackChunkName: "promotion" */ '@/views/dashboard/promotion/details.vue'),
      meta: { title: '推享赚二维码详情' }
    },
    {
      path: '/promotionintroduce',
      name: 'promotionintroduce',
      component: () => import(/* webpackChunkName: "promotion" */ '@/views/dashboard/promotion/introduce.vue'),
      meta: { title: '推享赚介绍' }
    },
    {
      path: '/promotionintroduceOther',
      name: 'promotionintroduceOther',
      component: () => import(/* webpackChunkName: "promotion" */ '@/views/dashboard/promotion/introduceOther.vue'),
      meta: { title: '推享赚说明' }
    },
    {
      path: '/purchaseShared',
      name: 'purchaseShared',
      component: () => import(/* webpackChunkName: "promotion" */ '@/views/dashboard/purchaseShared/index.vue'),
      meta: { title: '共享购介绍' }
    },
    {
      path: '/merchantsInviting',
      name: 'merchantsInviting',
      component: () => import(/* webpackChunkName: "promotion" */ '@/views/dashboard/merchantsInviting/index.vue'),
      meta: { title: '推荐商户' }
    },
    {
      path: '/atuishowinvite',
      name: 'atuishowinvite',
      component: () => import(/* webpackChunkName: "promotion" */ '@/views/dashboard/atuishowinvite/atuishowinvite.vue'),
      meta: { title: '体验购邀请' }
    },

    //  协议与说明相关（分组打包到 "agreement"  chunk）
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import(/* webpackChunkName: "agreement" */ '@/views/dashboard/privacy'),
      meta: { title: '隐私政策' }
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: () => import(/* webpackChunkName: "agreement" */ '@/views/dashboard/agreement'),
      meta: { title: '用户协议' }
    },
    {
      path: '/codeConduct',
      name: 'codeConduct',
      component: () => import(/* webpackChunkName: "agreement" */ '@/views/dashboard/codeConduct'),
      meta: { title: '阿推社区违规信息清单' }
    },
    {
      path: '/windowServiceAgreement',
      name: 'windowServiceAgreement',
      component: () => import(/* webpackChunkName: "agreement" */ '@/views/dashboard/windowServiceAgreement'),
      meta: { title: '阿推窗口开通服务协议' }
    },
    {
      path: '/experienceShow',
      name: 'experienceShow',
      component: () => import(/* webpackChunkName: "agreement" */ '@/views/introduceAll/experienceShow.vue'),
      meta: { title: '体验购说明' }
    },
    {
      path: '/experienceDisplayCabinet',
      name: 'experienceDisplayCabinet',
      component: () => import(/* webpackChunkName: "agreement" */ '@/views/dashboard/protocol/experienceDisplayCabinet.vue'),
      meta: { title: '阿推APP商家入驻“线下体验”出售展柜协议' }
    },
    {
      path: '/experienceDisplayCabinetBuy',
      name: 'experienceDisplayCabinetBuy',
      component: () => import(/* webpackChunkName: "agreement" */ '@/views/dashboard/protocol/experienceDisplayCabinetBuy.vue'),
      meta: { title: '购买阿推APP“线下体验”展柜格口协议' }
    },
    {
      path: '/childSexualPrevention',
      name: 'childSexualPrevention',
      component: () => import(/* webpackChunkName: "agreement" */ '@/views/dashboard/childSexualPrevention'),
      meta: { title: '儿童性虐待和性剥削 (CSAE) 防范标准' }
    },

    //  其他功能（分组打包到 "other"  chunk）
    {
      path: '/window',
      name: 'window',
      component: () => import(/* webpackChunkName: "other" */ '@/views/dashboard/window'),
      meta: { title: '文章详情' }
    },
    {
      path: '/hasWantNew',
      name: 'hasWantNew',
      component: () => import(/* webpackChunkName: "other" */ '@/views/dashboard/hasWantNew'),
      meta: { title: '我有我要详情' }
    },
    {
      path: '/mobileMaps',
      name: 'mobileMaps',
      component: () => import(/* webpackChunkName: "other" */ '@/views/dashboard/mobileMaps/index.vue'),
      meta: { title: '地图模块' }
    },
    {
      path: '/infoExpressDelivery',
      name: 'infoExpressDelivery',
      component: () => import(/* webpackChunkName: "other" */ '@/views/infoExpressDelivery')
    },
    {
      path: '/sales',
      name: 'sales',
      component: () => import(/* webpackChunkName: "other" */ '@/views/recruitAll/sales.vue'),
      meta: { title: '阿推招聘' }
    },
    {
      path: '/atuixiuCreateDescription',
      name: 'atuixiuCreateDescription',
      component: () => import(/* webpackChunkName: "other" */ '@/views/dashboard/atuixiuCreateDescription/index.vue'),
      meta: { title: '体验购创建说明' }
    },
    {
      path: '/atuiGuide',
      name: 'atuiGuide',
      component: () => import(/* webpackChunkName: "other" */ '@/views/dashboard/atuiGuide/index.vue'),
      meta: { title: '' }
    },
    {
      path: '/atuixiuVideo',
      name: 'atuixiuVideo',
      component: () => import(/* webpackChunkName: "other" */ '@/views/dashboard/videoDemonstration/atuixiu.vue'),
      meta: { title: '体验购视频介绍' }
    },
    {
      path: '/myPhoneRelation',
      name: 'myPhoneRelation',
      component: () => import(/* webpackChunkName: "other" */ '@/views/dashboard/myPhoneRelation/index.vue'),
      meta: { title: '二维码校验' }
    },
    {
      path: '/miniprogramInfo',
      name: 'miniprogramInfo',
      component: () => import(/* webpackChunkName: "other" */ '@/views/miniprogramInfo/index.vue'),
      meta: { title: '如何获取小程序APPID与原始ID' }
    },
    {
      path: '/cooperation-agreement',
      name: 'CooperationAgreement',
      component: () => import(/* webpackChunkName: "other" */ '@/views/dashboard/CooperationAgreement/CooperationAgreement.vue'),
      meta: { title: '阿推APP加盟店合作协议' }
    },
    {
      path: '/wechat-verify',
      name: 'WechatVerify',
      component: () => import(/* webpackChunkName: "WechatVerify" */ '@/views/dashboard/WechatVerify/WechatVerify.vue'),
      meta: { title: '安全验证' }
    },
    {
      path: '/choice-goods-qa',
      name: 'ChoideGoodsQa',
      component: () => import(/* webpackChunkName: "ChoiceGoods" */ '@/views/ChoiceGoods/ChoiceGoodsQa/ChoiceGoodsQa.vue'),
      meta: { title: '选品广场' }
    },
    {
      path: '/app-choice-location',
      name: 'AppChoiceLocation',
      component: () => import(/* webpackChunkName: "AppChoiceLocation" */ '@/views/AppChoiceLocation/AppChoiceLocation.vue'),
      meta: { title: '选择店铺地址' }
    },
    {
      path: '/shop-management',
      name: 'ShopManagement',
      meta: { title: '阿推商户管理系统' },
      component: () => import(/* webpackChunkName: "ShopManagement" */ '@/views/ShopManagement/index.vue'),
      children: [
        {
          path: 'login',
          name: "ShopManagementLogin",
          component: () => import(/* webpackChunkName: "ShopManagement" */ '@/views/ShopManagement/login/login.vue'),
          meta: { title: '阿推商户管理系统' }
        },
        {
          path: 'edit-information',
          name: "ShopManagementEditInformation",
          component: () => import(/* webpackChunkName: "ShopManagement" */ '@/views/ShopManagement/EditInformation/EditInformation.vue'),
          meta: { title: '阿推商户管理系统' }
        },
        {
          path: 'choice-business',
          name: "ChoiceBusiness",
          component: () => import(/* webpackChunkName: "ShopManagement" */ '@/views/ShopManagement/ChoiceBusiness/ChoiceBusiness.vue'),
          meta: { title: '阿推商户管理系统' }
        },
        {
          path: 'select-areaCode',
          name: "SelectAreaCode",
          component: () => import(/* webpackChunkName: "ShopManagement" */ '@/views/ShopManagement/SelectAreaCode/SelectAreaCode.vue'),
          meta: { title: '阿推商户管理系统' }
        },
        {
          path: 'edit-address',
          name: "EditAddress",
          component: () => import(/* webpackChunkName: "ShopManagement" */ '@/views/ShopManagement/EditAddress/EditAddress.vue'),
          meta: { title: '阿推商户管理系统' }
        },
        {
          path: 'choice-location',
          name: "ChoiceLocation",
          component: () => import(/* webpackChunkName: "ShopManagement" */ '@/views/ShopManagement/ChoiceLocation/ChoiceLocation.vue'),
          meta: { title: '阿推商户管理系统' }
        },
        {
          path: 'management-index',
          name: "ManagementIndex",
          component: () => import(/* webpackChunkName: "ShopManagement" */ '@/views/ShopManagement/ManagementIndex/ManagementIndex.vue'),
          meta: { title: '阿推商户管理系统' }
        },
        {
          path: 'publish-products',
          name: "PublishProducts",
          component: () => import(/* webpackChunkName: "ShopManagement" */ '@/views/ShopManagement/PublishProducts/PublishProducts.vue'),
          meta: { title: '阿推商户管理系统' }
        },
        {
          path: 'goods-audit-status',
          name: "GoodsAuditStatus",
          component: () => import(/* webpackChunkName: "ShopManagement" */ '@/views/ShopManagement/GoodsAuditStatus/GoodsAuditStatus.vue'),
          meta: { title: '阿推商户管理系统' }
        },
        {
          path: 'settlein-introduction',
          name: "SettleinIntroduction",
          component: () => import(/* webpackChunkName: "ShopManagement" */ '@/views/ShopManagement/SettleinIntroduction/SettleinIntroduction.vue'),
          meta: { title: '阿推商户管理系统' }
        },
        {
          path: 'shop-management-agreement',
          name: "ShopManagementAgreement",
          component: () => import(/* webpackChunkName: "ShopManagementAgreement" */ '@/views/ShopManagement/ShopManagementAgreement/ShopManagementAgreement.vue'),
          meta: { title: '阿推平台服务协议' }
        },
        {
          path: 'promotion-agreement',
          name: "PromotionAgreement",
          component: () => import(/* webpackChunkName: "PromotionAgreement" */ '@/views/ShopManagement/PromotionAgreement/PromotionAgreement.vue'),
          meta: { title: '体验购推广协议' }
        }
      ]
    },
    {
      path: '/sample-ground-list',
      name: 'SampleGroundList',
      component: () => import(/* webpackChunkName: "SampleGroundList" */ '@/views/SampleGroundList/SampleGroundList.vue'),
      meta: { title: '' }
    },
    {
      path: '/sample-ground-details',
      name: 'SampleGroundDetails',
      component: () => import(/* webpackChunkName: "SampleGroundList" */ '@/views/SampleGroundDetails/SampleGroundDetails.vue'),
      meta: { title: '' }
    },
    {
      path: '/festival-poster',
      name: 'FestivalPoster',
      component: () => import(/* webpackChunkName: "FestivalPoster" */ '@/views/FestivalPoster/FestivalPoster.vue'),
      meta: { title: '' }
    },
    {
      path: '/holiday-arrangement',
      name: 'HolidayArrangement',
      component: () => import(/* webpackChunkName: "HolidayArrangement" */ '@/views/HolidayArrangement/HolidayArrangement.vue'),
      meta: { title: '' }
    },
    {
      path: '/questionnaire',
      name: 'Questionnaire',
      component: () => import(/* webpackChunkName: "Questionnaire" */ '@/views/Questionnaire/Questionnaire.vue'),
      meta: { title: '' }
    },
    {
      path: '/questionnaire-success',
      name: 'QuestionnaireSuccess',
      component: () => import(/* webpackChunkName: "QuestionnaireSuccess" */ '@/views/QuestionnaireSuccess/QuestionnaireSuccess.vue'),
      meta: { title: '' }
    },
    {
      path: '/instant-deal-agreement',
      name: 'InstantDealAgreement',
      component: () => import(/* webpackChunkName: "InstantDealAgreement" */ '@/views/InstantDealAgreement/InstantDealAgreement.vue'),
      meta: { title: '即时惠发布者协议' }
    },
    {
      path: '/instant-deal-details',
      name: 'InstantDealDetails',
      component: () => import(/* webpackChunkName: "InstantDealDetails" */ "@/views/InstantDealDetails/InstantDealDetails.vue"),
      meta: { title: '即时惠详情' }
    },
    {
      path: '/instant-deal-explain',
      name: 'InstantDealExplain',
      component: () => import(/* webpackChunkName: "InstantDealExplain" */ "@/views/InstantDealExplain/InstantDealExplain.vue"),
      meta: { title: '即时惠说明' }
    },
    {
      path: '/instant-deal-rank-list',
      name: 'InstantDealRankList',
      component: () => import(/* webpackChunkName: "InstantDealRankList" */ "@/views/InstantDealRankList/InstantDealRankList.vue"),
      meta: { title: '即时惠说明' }
    },
    {
      path: '/deal-edit-picture',
      name: 'DealEditPicture',
      component: () => import(/* webpackChunkName: "DealEditPicture" */ "@/views/DealEditPicture/DealEditPicture.vue"),
      meta: { title: '即时惠说明' }
    },
  ]
})
